import { addDays } from "../../cpcoc/addDays";
import { days } from "../../cpcoc/days";
import { months } from "../../cpcoc/months";
import { getActiveDate } from "./dates";
import { getBibleReadingTime } from "./getBibleReadingTime";
import { getDateContent } from "./getDataContent";
import { getDateState } from "./getDateState";
import { getPlanByDate } from "./readingPlan";
export function weekBody() {
    var _a, _b, _c;
    let html = "<ul>";
    // const date = new Date(dates.active);
    let date = getActiveDate();
    const weekCombinedReading = [];
    let totalReadingCount = 0;
    const dayIndex = date.getDay() || days.length;
    date = addDays(date, dayIndex * -1); // sets to start of the week
    for (let i = 0; i < days.length; i++) {
        date = addDays(date, 1);
        const plan = getPlanByDate(date);
        const readingTimeId = `reading-time-${i}`;
        const content = getDateContent(plan);
        const dayCombinedReading = plan.currentPlan
            ? plan.currentPlan.reading.join(",")
            : "";
        if (dayCombinedReading) {
            weekCombinedReading.push(dayCombinedReading);
        }
        totalReadingCount += plan.currentPlan
            ? plan.currentPlan.reading.length
            : 0;
        html += `
        <li class="bible-reading__week-item ${getDateState(date)}">
          <div class="date-content">
            <div class="col">
              <p class="bible-reading__week-day">${days[date.getDay()]}</p>
              <p class="bible-reading__week-date">${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}</p>
              ${((_a = plan.currentPlan) === null || _a === void 0 ? void 0 : _a.reading.length)
            ? `<p class="bible-reading__week-meta" id="${readingTimeId}"></p>`
            : ""}
            </div>
            <div class="col">
              <article class="bible-reading__template">
                ${content}
              </article>
              ${((_b = plan.currentPlan) === null || _b === void 0 ? void 0 : _b.reading.length) > 1
            ? `<p class="bible-reading__week-footer print-hide"><a href="https://cedarparkchurchofchrist.org/bible?q=${dayCombinedReading}">Read all passages</a></p>`
            : ""}
            </div>
          </div>
        </li>
      `;
        ((_c = plan.currentPlan) === null || _c === void 0 ? void 0 : _c.reading.length) &&
            getBibleReadingTime(dayCombinedReading, `#${readingTimeId}`);
    }
    html += "</ul>";
    if (weekCombinedReading.length && totalReadingCount > 1) {
        html += `<p class="bible-reading__week-all print-hide"><a class="bible-reading__paginate-btn" href="https://cedarparkchurchofchrist.org/bible?q=${weekCombinedReading}">Read all passages <em>(<span id="full-week-reading-time"></span>)</em></a></p>`;
        getBibleReadingTime(weekCombinedReading.toString(), `#full-week-reading-time`);
    }
    return html;
}
